export default "__VITE_ASSET__uzjmBO1p__"